<template>
    <div class='mt30 sk__title elem'></div>
</template>

<script>
export default {};
</script>

<style scoped lang='less'>
@import "theme/moydom/less/variables.less";

.sk {
    &__title {
        max-width: 780px;
        height: 40px;
        margin: 80px 0;
        border-radius: 40px;

        @media (max-width: @screen-lg) {
            height: 40px;
            margin: 70px 0;
        }

        @media (max-width: @screen-md) {
            height: 30px;
            margin: 70px 0;
        }

        @media (max-width: @screen-sm) {
            margin: 60px 0;
        }

        @media (max-width: @screen-xs) {
            margin: 50px 0;
        }
    }
}

.elem {
    background: #e7e7e7;
    position: relative;
    overflow: hidden;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(90deg,
        transparent 0%,
        #c3c3c361 30%,
        transparent 100%);
        animation: load 2s infinite;
        content: '';
    }
}

@keyframes load {
    100% {
        transform: translateX(100%);
    }
}


</style>
